import { getText } from '@storebrand-digital/fms-translations';
import { validateNinStrict } from '@storebrand-digital/storebrand-common-validation';

import type { FmsKeys } from '@utils/fmsTypes/FmsTypes';

export function getTextWithVariables({
  fmsKey,
  placeholder,
  variables,
}: {
  fmsKey: FmsKeys;
  placeholder: string;
  variables: (number | string)[];
}) {
  let text = getText(fmsKey);
  variables.forEach((variable) => {
    text = text.replace(placeholder, `${variable}`);
  });
  return text;
}

export function monthsToYearsAndMonths(months: number) {
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;
  return {
    months: remainingMonths,
    years,
  };
}

export function formatAsAccountNumber(accountNumber: string) {
  return accountNumber.replace(/(\d{4})(\d{2})(\d{5})/, '$1.$2.$3');
}

export function formatNumber(value: number) {
  return new Intl.NumberFormat('nb-NO').format(value);
}

export function formatDate(
  date: Date,
  options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }
) {
  return new Intl.DateTimeFormat('nb-NO', options).format(date);
}

export function formatAsCurrency(value: number, currencySuffix = 'NOK') {
  return `${formatNumber(value)} ${currencySuffix}`;
}

const searchParam = new URLSearchParams(window.location.search);

export const isWebView = searchParam.get('displaymode') === 'app';
export const isE2E = window.env.ENVIRONMENT === 'E2E';

export function isNinValid(nin?: string) {
  if (!nin) {
    return false;
  }
  return validateNinStrict(nin).valid;
}

export function sanitizeAccountNumber(accountNumber: string) {
  return accountNumber.replace(/[^0-9]/g, '');
}

export function roundTo(value: number, base: number) {
  return Math.round(value / base) * base;
}

export function toInternationalNumberNaNSafe(value: number): string {
  return Number.isFinite(value) ? Intl.NumberFormat('nb-NO').format(value) : '';
}
